import { 
  Palette, 
  ChefHat, 
  Dumbbell, 
  Brain, 
  Gamepad2, 
  PartyPopper, 
  Dog, 
  Laptop, 
  Heart, 
  BookOpen, 
  MessageCircle, 
  Star, 
  Lightbulb 
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

// Icon mapping for database categories
export const categoryIconMap: Record<string, LucideIcon> = {
  Palette,
  ChefHat,
  Dumbbell,
  Brain,
  Gamepad2,
  PartyPopper,
  Dog,
  Laptop,
  Heart,
  BookOpen,
  MessageCircle,
  Star,
  Lightbulb,
};

// Color mapping using ONLY the brand logo colors (12-segment color wheel)
// Logo palette: indigo, blue, sky, green, lime, yellow, amber/orange, red-orange,
// rose, pink, magenta/purple, violet
export const categoryColorMap: Record<string, string> = {
  peach: 'bg-[#F39A2B]',       // amber/orange
  sky: 'bg-[#3FAFE0]',         // sky blue
  mint: 'bg-[#7FC242]',        // lime green
  coral: 'bg-[#E84C3D]',       // red-orange
  lavender: 'bg-[#5E4FA2]',    // indigo
  blush: 'bg-[#E94B7B]',       // pink
  terracotta: 'bg-[#EF6C2E]',  // orange
  sage: 'bg-[#3FA864]',        // green
  sunshine: 'bg-[#F5C518]',    // yellow
  rose: 'bg-[#D63384]',        // magenta
  // extras mapped to remaining wheel colors
  indigo: 'bg-[#2E68B8]',      // blue
  violet: 'bg-[#8E44AD]',      // violet/purple
};

// Default color for categories without a color (use brand primary)
export const defaultCategoryColor = 'bg-primary';

// Default icon for categories without an icon
export const DefaultCategoryIcon = Palette;

// Helper function to get category icon
export function getCategoryIcon(iconName: string | null): LucideIcon {
  return categoryIconMap[iconName || 'Palette'] || DefaultCategoryIcon;
}

// Helper function to get category color class
export function getCategoryColorClass(colorName: string | null): string {
  return categoryColorMap[colorName || ''] || defaultCategoryColor;
}

// Brand logo color wheel — order matches the logo's clockwise rotation
// starting from the top: blue → sky → green → lime → yellow → orange →
// red-orange → pink → magenta → violet → indigo → (back to blue)
export const brandWheelColors: string[] = [
  'bg-[#2E68B8]', // blue (top)
  'bg-[#3FAFE0]', // sky
  'bg-[#3FA864]', // green
  'bg-[#7FC242]', // lime
  'bg-[#F5C518]', // yellow
  'bg-[#F39A2B]', // amber/orange
  'bg-[#EF6C2E]', // orange
  'bg-[#E84C3D]', // red-orange
  'bg-[#E94B7B]', // pink
  'bg-[#D63384]', // magenta
  'bg-[#8E44AD]', // violet
  'bg-[#5E4FA2]', // indigo
];

// Returns a unique brand color for a card based on its index, ensuring
// every card on a page gets a distinct logo color.
export function getBrandColorByIndex(index: number): string {
  return brandWheelColors[index % brandWheelColors.length];
}

// Raw hex values matching brandWheelColors (same order)
export const brandWheelHex: string[] = [
  '#2E68B8', '#3FAFE0', '#3FA864', '#7FC242', '#F5C518', '#F39A2B',
  '#EF6C2E', '#E84C3D', '#E94B7B', '#D63384', '#8E44AD', '#5E4FA2',
];

export function getBrandHexByIndex(index: number): string {
  return brandWheelHex[index % brandWheelHex.length];
}

